<template>
  <ModalVue @close="close" :modalActive="modalActive" max-width="max-w-lg">
    <template #header>
      <p class="font-bold text-start">Filtrar Políticas</p>
    </template>

    <div class="flex flex-col gap-4">
      <v-autocomplete
        v-model="selectedCompanies"
        :items="listCompanies"
        item-title="title"
        item-value="value"
        label="Selecione as Empresas"
        multiple
        chips
        clearable
        deletable-chips
        variant="outlined"
        class="w-full"
        data-testid="filter-company-select"
      />
    </div>

    <template #footer>
      <div class="flex flex-row gap-2">
        <OutlineButton
          @click="clearFilters"
          text="Limpar filtros"
          width="50%"
          data-testid="filter-clear-button"
        />
        <FilledButton
          :disabled="!hasFilters"
          @click="applyFilters"
          text="Aplicar Filtros"
          width="50%"
          class="!bg-primary30"
          data-testid="filter-apply-button"
        />
      </div>
    </template>
  </ModalVue>
</template>

<script setup lang="ts">
import { ref, watchEffect, computed } from 'vue'

import ModalVue from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'

import { storeToRefs } from 'pinia'
import { useCompanyStore } from '@/pinia-store/useCompanyStore'

export interface QualificationTransferFilters {
  companies: string[]
}

const props = defineProps<{
  modalActive: boolean
  appliedFilters?: QualificationTransferFilters
}>()

const emit = defineEmits<{
  close: []
  'apply-filters': [filters: QualificationTransferFilters]
}>()

const { listCompanies } = storeToRefs(useCompanyStore())

const selectedCompanies = ref<string[]>([])

const hasFilters = computed(() => selectedCompanies.value.length > 0)

function applyFilters() {
  emit('apply-filters', { companies: selectedCompanies.value })
  emit('close')
}

function clearFilters() {
  selectedCompanies.value = []
  emit('apply-filters', { companies: [] })
  emit('close')
}

function close() {
  emit('close')
}

watchEffect(() => {
  if (props.modalActive && props.appliedFilters) {
    selectedCompanies.value = props.appliedFilters.companies || []
  }
})
</script>
